import { ThisData } from "../utils/Data"

export const Home = () => {
    return (
        <div className="container mx-auto">
            <ThisData />
        </div >
    )
}